// Generic summary row: icon, title, value and an optional edit pencil. Same layout and
// typography as the Figma summary rows (PassengerInfo, MessageToDriver, SelectedCar).
import classnames from 'classnames'
import { SummaryIcon, Icon } from '~/components'

export default function BookingSummaryField({ title, value, icon, changeToggle, required, empty, disabled }) {
  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      <div className="shrink-0 size-11 flex items-center justify-center">
        <SummaryIcon id={icon} />
      </div>

      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{title}</span>
        {value && (
          <span className={classnames('text-[15px] leading-5', required && empty ? 'text-[#da0a2b]' : 'text-on-surface-variant')}>
            {value}
          </span>
        )}
      </div>

      {changeToggle && !disabled && (
        <button type="button" onClick={() => changeToggle()} className="shrink-0 p-2 -mr-2" aria-label={title}>
          <Icon id="pen" />
        </button>
      )}
    </div>
  )
}
